/**
 * Convert an hours string into an array of strings by splitting on commas and newlines.
 *
 * Example:
 * ```
 * parseCampusHours("Monday: 9:00 AM - 5:00 PM, Tuesday: 9:00 AM - 5:00 PM")
 * // ["Monday: 9:00 AM - 5:00 PM", "Tuesday: 9:00 AM - 5:00 PM"]
 * ```
 *
 * @param hours - The hours string to parse
 */
const parseCampusHours = (hours?: string) => {
	if (!hours) {
		return [];
	}
	return hours.split(/[,\n]/);
};

export default parseCampusHours;
